'use client'
const ShariahItem = ({ Icon, header, subheader, className = '' }) => {
  return (
    <div className={`col-12 custom-column-2 item-container ${className}`}>
      <img src={Icon} alt="Icon" className="icon" />
      <div className="column-header-2 item-header">{header}</div>
      <div className="column-subheader-2 item-subheader">{subheader}</div>
    </div>
  )
}

export default ShariahItem
